import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step3a', 'Step 3a: Has the employer established reasonable standards with regard to which employees are eligible to participate in the plan and which are not?', {
        nextComponent: () => 'step3b',
        result() {
            if(this.answers.step3a == null) return [];
            return [{ question: this.question, result: this.passed ? 'Pass' : 'Fail' }];
        },
        reasonableStandards: () => [
            'Excluding part-time employees',
            'Excluding seasonal and/or temporary employees',
            'Excluding employees under age 21',
            'Excluding employees covered under a separate collective bargaining agreement (i.e. "union" employees)',
            'Making geographic or departmental distinctions among employees so long as these do not result in non-HCEs being excluded disproportionately from HCEs'
        ],
        nonReasonableStandards: () => [
            'Reserving participation for managers and/or executives only',
            'Reserving participation only for employees above a given income level',
            'Any standard that appears reasonable on its face but results in discrimination against non-HCEs in operation'
        ],
        template: `
        <question :question="question" v-model="answer">
            <template v-slot:note>
                <div class="row">
                    <help-block label="NOTE: This rule prohibits employers from making arbitrary decisions with regard to participation in the plan. This is a somewhat subjective measure, but what follows are some examples of what are generally regarded as reasonable standards:" :items="reasonableStandards" />
                    <help-block label="Examples of standards that are generally not reasonable include but are not limited to:" :items="nonReasonableStandards" />
                </div>
            </template>
        </question>
        `,
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step3a.js